import request from '@/utils/request';
import config from '@/constants/env.config';

const API = config.APP_API;

export interface ReqGetStreamLink {
  id: string;
  playindex: number;
}

export interface ReqGetShareData {
  type: number;
  catHouseId?: string;
  shareType?: number;
}

export interface ReqUserFeedDetail {
  userFeedId: string;
  userId?: string;
}

export interface RechargeConfig {
  catCoin: number;
  configInvitedFeedFirst: number;
  configPayValue1: number;
  configPayValue2: number;
  configPayValue3: number;
  configPayValue4: number;
  configPayValue5: number;
  configPayValue6: number;
  configPayValue7: number;
  configPayKey1: number;
  configPayKey2: number;
  configPayKey3: number;
  configPayKey4: number;
  configPayKey5: number;
  configPayKey6: number;
  configPayKey7: number;
}

export interface BannerVo {
  url: string;
}
export interface CatHouseVo extends RechargeConfig {
  exclusiveCoin: number;
  liveplayerId: string;
  address: string;
  bucketCapacity: number;
  historicalEatWeight: number | undefined;
  catHouseDeviceId: string;
  catHouseDeviceKey: string;
  createTime: number;
  describes: string;
  deviceBattery: string;
  deviceBluetooth: string;
  deviceCatGps: string;
  deviceCharging: string;
  deviceFood: string;
  deviceInfo: string;
  deviceLte: string;
  deviceSolarEnergy: string;
  deviceTemperature: string;
  deviceUserLock: boolean;
  feedToday: number;
  historyImage: string;
  id: string;
  isCat: number;
  isDelete: number;
  isOperationShow: number;
  isSubscribe: boolean;
  lastFeedTime: string;
  latitude: string;
  longitude: string;
  name: string;
  occurrenceTimesToday: number;
  qrCode: string;
  shufflingImage: string;
  stream1: string;
  stream2: string;
  stream3: string;
  streamJson: string;
  streamLink: string;
  updateTime: number;
  upperLimit: number;
  waterCount: string;
  coverImage: string;
  dateText?: string;
  feedNumberToday: number;
  subscribeNumber: number;
  distance: string;
  isOperation?: boolean;
  shufflingImgJson?: string[];
  coverImageUrl?: string;
  isMuted: boolean;
  isPromptEmptyPlate?: boolean | null;
  todayFeedCount: number;
  configUserFeedLimit: string;
  todayUserFeedCount: number;
  subscribeCount: number;
  configFeed: number;
  catCoin: number;
  configFeedCount: number;
  feedQuota: number;
  todayShowCount: number;
  todayFeedUserCount: number;
  configInvitedFeedFirst: number;
  bannerList: BannerVo[];
  historyUrl: BannerVo[];
  deviceLight: string;
  runDays: number;
  userSubsCount: number;
  updateTimeAgo: string;
  skipGuide: boolean;
  useAmin: boolean;
  stockFoodsFlag?: number | boolean | null;
  feedCatHouseNumber: number;
  thisUserFeedCount: number;
  feedTimes: number;
  numberOfFeedRank: number;
  nickname: string;
  onlineUser: number;
  postUrl: string;
  avatar: string;
  htmlNodes?: [];
  userType?: number; // 1-获得邀请返币的用户.2-未获得邀请返币的用户
  shared?: boolean; // 是否分享过
  configLoginFirst?: string; // 首次注册奖励
  newUserReward1?: string; // 新用户访问礼1
  newUserReward2?: string; // 新用户访问礼2
  newUserReward3?: string; // 新用户访问礼3
  batteryLevel?: string; // 电池
  deviceId?: string; // 设备ID
  catHouseBoxId?: string; // 猫屋外观ID
  deviceOperationLock?: string; // 设备锁状态
  liveNoticeContext?: string; // 公告,
  noticeFlag?: boolean;
  noticeId?: string; // 公告id,

  plateWeight: number | undefined;
}

interface catLabelsVo {
  name: string;
  avatar: string;
  catLabelId: string;
}
export interface pictureVo {
  feedPicture: string;
  url?: string;
  catLabels: catLabelsVo[];
}

export interface videoVO {
  feedPicture: string;
  url: string;
}
export interface cardDetailVo extends CatHouseVo {
  tags?: number[];
  catHouseName?: string;
  feedCatCount?: number;
  content: string;
  feedQuantity?: number;
  picture?: pictureVo[];
  avatar: string;
  videos?: videoVO[];
  nickname: string;
  sendUserId: string;
  contentType?: number;
  id: string;
  isPrefer: number;
  catHouseId: string;
  preferNum: number;
  shareNum: number;
  commentNum: number;
  activityFlag?: boolean;
}

export interface HttpResponse<T> {
  code: number;
  data: T;
  msg?: string;
  result?: T;
  message?: string;
}

export interface BarrageItem {
  opeDescription: string;
  userName: string;
}

export interface ResShareData {
  barName: string;
  barrageList: BarrageItem[];
  catHouseList: {
    catHouseName: string;
    coverImage: string;
    todayFeedNum: number;
    todayViewUserNum: number;
  }[];
  topPreferFeedList: {
    content: string;
    avatar: string;
    nickname: string;
    preferCount: number;
  }[];
  coverImages: string[];
  userCount: number;
  vedioLink: string;
}

export interface ResUserFeedData {
  appBadgeFlag: boolean;
  commentCount: number;
  isPrefer: number;
  isSelf: number;
  preferCount: number;
  shareCount: number;
}

export interface ResWxJsConfigSignature {
  timestamp: string;
  nonceStr: string;
  signature: string;
}

// 获取二次分享小卡片信息入参
export interface ReqGetSecondShareCard {
  shareType:
    | string
    | number /** 1 图片 2 视频 3 直播 4/0/undefined 其他（图片） */;
  businessId?: string /** 1 2 动态id 3 猫屋id */;
}

// 获取二次分享小卡片信息出参
export interface ResGetSecondShareCard {
  shareTitle: string /** 分享主标题 */;
  shareSubTitle: string /** 分享副标题 */;
  imgUrl?: string /** 分享图标 */;
}

export const getStreamLinkApi = async (
  param: ReqGetStreamLink,
): Promise<string> => {
  try {
    const response = await request.post(
      `${API}/api/pet.user.app.home.getStreamLink`,
      { ...param }
    );

    return response.data;
  } catch (error) {
    throw new Error('Failed to get stream link');
  }
};

export const getShareDataApi = (
  param: ReqGetShareData,
): Promise<HttpResponse<ResShareData>> =>
  request.post(`${API}/api/pet.user.app.getShareData`, {
    action: 'pet.user.app.getShareData',
    ...param,
  });

export const getUserFeedDetailApi = (
  param: ReqUserFeedDetail,
): Promise<HttpResponse<cardDetailVo>> =>
  request.post(`${API}/api/pet.user.app.getUserFeedDetail`, {
    action: 'pet.user.app.getUserFeedDetail',
    ...param,
  });

export const getUserFeedDataApi = (
  param: ReqUserFeedDetail,
): Promise<HttpResponse<ResUserFeedData>> =>
  request.post(`${API}/api/pet.user.app.getUserFeedData`, {
    action: 'pet.user.app.getUserFeedData',
    ...param,
  });

export const getWxJsConfigSignatureApi = (
  param: Record<string, string>,
): Promise<HttpResponse<ResWxJsConfigSignature>> => {
  const params = {
    action: 'wechat.sa.sign',
    bizCode: 'Mi13',
    url: window.location.href.split('#')[0],
    ...param,
  };
  return request.post('https://api.hellobike.com/api', params);
};

export const requestGetSecondShareCardApi = (
  param: ReqGetSecondShareCard,
): Promise<HttpResponse<ResGetSecondShareCard>> =>
  request.post(`${API}/api/pet.user.getSecondShareCard`, {
    action: 'pet.user.getSecondShareCard',
    ...param,
  });
